<template>
  <Base :is-loading="modalData !== ''" :base-id="'modal-share'" :base-class="'share-content'">
    <template #body>
      <div class="icon-wrap">
        <a
          class="btn-share-this"
          data-social="IG"
          href="#"
          @click.prevent="shareToSocial($event, modalData)"
        >
          <i class="icon-ig" />
        </a>
        <a
          class="btn-share-this"
          data-social="fb"
          href="#"
          @click.prevent="shareToSocial($event, modalData)"
        >
          <i class="icon-fb" />
        </a>
        <a
          class="btn-share-this"
          data-social="line"
          href="#"
          @click.prevent="shareToSocial($event, modalData)"
        >
          <i class="icon-line" />
        </a>
        <a
          class="btn-share-this"
          data-social="twitter"
          href="#"
          @click.prevent="shareToSocial($event, modalData)"
        >
          <i class="icon-twitter" />
        </a>
        <a
          class="btn-share-this"
          data-social="wechat"
          href="#"
          @click.prevent="shareToSocial($event, modalData)"
        >
          <i class="icon-wechat" />
        </a>
        <a
          class="btn-share-this"
          data-social="whatsapp"
          href="#"
          @click.prevent="shareToSocial($event, modalData)"
        >
          <i class="icon-whatsapp" />
        </a>
      </div>
      <div class="link-wrap">
        <input id="share-link" readonly :value="modalData" class="share-link-hidden" type="text" />
        <button id="copyLink" data-clipboard-target="#share-link" @click.prevent="copy(closeModal)">
          複製連結
        </button>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import useModalStore from '@global/stores/useModalStore';
import useShare from '@global/composable/useShare';

import Base from '@global/components/common/modal/Base.vue';

const { shareToSocial, copy } = useShare();
const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);
</script>
